import { Component } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DateRange } from './custom-date-range-picker.component';

@Component({
  selector: 'app-date-range-picker-demo',
  templateUrl: './date-range-picker-demo.component.html',
  styleUrls: ['./date-range-picker-demo.component.scss']
})
export class DateRangePickerDemoComponent {
  demoForm: FormGroup;
  minDate: Date = new Date(2020, 0, 1);
  maxDate: Date = new Date(2030, 11, 31);

  constructor(private fb: FormBuilder) {
    this.demoForm = this.fb.group({
      basicRange: [null],
      withMinMax: [null],
      disabledRange: [null],
      customPlaceholder: [null],
      preSelectedRange: [{
        startDate: new Date(2024, 5, 15),
        endDate: new Date(2024, 5, 20)
      }]
    });
  }

  onDateRangeChange(dateRange: DateRange) {

  }

  onSubmit() {
 
  }

  clearAllRanges() {
    this.demoForm.reset();
  }
} 